'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { cn } from '../../../shared/cn';
type DropdownMenuProps = {
  anchor?: Headless.MenuItemsProps['anchor'] | false;
  portal?: boolean;
  className?: string;
  style?: React.CSSProperties;
};
export function DropdownMenu(t0) {
  const $ = _c(14);
  let anchor;
  let className;
  let portal;
  let props;
  let style;
  if ($[0] !== t0) {
    ({
      anchor,
      portal,
      className,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = anchor;
    $[2] = className;
    $[3] = portal;
    $[4] = props;
    $[5] = style;
  } else {
    anchor = $[1];
    className = $[2];
    portal = $[3];
    props = $[4];
    style = $[5];
  }
  const resolvedAnchor = anchor === false ? undefined : anchor ?? "bottom";
  let t1;
  if ($[6] !== className) {
    t1 = cn("[--anchor-gap:--spacing(2)] [--anchor-padding:--spacing(1)] data-[anchor~=end]:[--anchor-offset:6px] data-[anchor~=start]:[--anchor-offset:-6px] sm:data-[anchor~=end]:[--anchor-offset:4px] sm:data-[anchor~=start]:[--anchor-offset:-4px]", "isolate w-max rounded-xl p-1", "outline outline-transparent focus:outline-hidden", "custom-scrollbar! overflow-y-auto", "bg-backgroundPrimary", "border-borderPrimary border-t", "shadow-sm", "supports-[grid-template-columns:subgrid]:grid supports-[grid-template-columns:subgrid]:grid-cols-[auto_1fr_1.5rem_0.5rem_auto]", "transition data-closed:data-leave:opacity-0 data-leave:duration-100 data-leave:ease-in", className);
    $[6] = className;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== portal || $[9] !== props || $[10] !== resolvedAnchor || $[11] !== style || $[12] !== t1) {
    t2 = <Headless.MenuItems {...props} portal={portal} transition={true} anchor={resolvedAnchor} style={style} className={t1} />;
    $[8] = portal;
    $[9] = props;
    $[10] = resolvedAnchor;
    $[11] = style;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}